module.exports = __webpack_public_path__ + "components/flag/static/square/na-b39d640fc59c5853dc37b7f93ab1b7d5.svg";